'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var Icon = require('../../Icon/src/Icon.js');
var Space = require('../../Space/src/Space.js');
var Breadcrumb_module = require('../styles/Breadcrumb.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description A breadcrumb displays the current location within a hierarchy. It allows going back to states higher up in the hierarchy
 *
 * @component
 * @example
 * ```jsx
 * <Breadcrumb>
 *   <Breadcrumb.Item>Home</Breadcrumb.Item>
 * </Breadcrumb>
 * ```
 */
const Breadcrumb = React__namespace.forwardRef((props, ref) => {
    const { className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Breadcrumb_module.default);
    const classNames = cx(className, 'container');
    const count = React__namespace.useMemo(() => React__namespace.Children.count(children), [children]);
    const navigation = React__namespace.useMemo(() => React__namespace.Children.map(children, (child, index) => (React__namespace.createElement(React__namespace.Fragment, null,
        child,
        index + 1 < count && React__namespace.createElement(Icon.Icon, { size: 16, icon: React__namespace.createElement(reactIcons.ArrowRight, null) })))), [children, count]);
    return (React__namespace.createElement(Space.Space, { ref: ref, "data-qa": "Breadcrumb", align: "center", size: 8, className: classNames, ...restProps }, navigation));
});
Breadcrumb.defaultProps = {};
Breadcrumb.displayName = 'Breadcrumb';

exports.Breadcrumb = Breadcrumb;
//# sourceMappingURL=Breadcrumb.js.map
